export default [

     {
          path: '/qualification',
          name: 'Qualification',
          component: () => import("@/views/Page/Qualification/Qualification.vue"),
          meta: {
               title: 'Qualifications',
          },
     }
];